import { baseUrl } from "../utilities/configurations";
import { useNavigate } from "react-router-dom";
import apiRequest from "../utilities/request";
import PropTypes from "prop-types";
import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useMemo,
} from "react";

const LOAReimbursementContext = createContext();

export function useLOAReimbursementContext() {
  return useContext(LOAReimbursementContext);
}

export function LOAReimbursementProvider(props) {
  const [selectedPolicy, setSelectedPolicy] = useState(null);
  const [displayAlert, setDisplayAlert] = useState(false);

  const [policyLoadState, setPolicyLoadState] = useState([]);
  const [loaPolicies, setLoaPolicies] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    getPolicy();
  }, []);

  const getPolicy = async (state) => {
    try {
      setPolicyLoadState(state || "load");
      const res = await apiRequest(baseUrl + `/policy/loa-policies`, "GET");
      if (!res.error) {
        setLoaPolicies(res.data || []);
        setPolicyLoadState("load success");
      } else if (res.status >= 500) {
        setPolicyLoadState("ISE");
      } else {
        setPolicyLoadState("load failed");
      }
    } catch (error) {
      setPolicyLoadState("timeout");
    }
  };

  const handleBack = (e) => {
    navigate(-1);
  };

  const data = useMemo(
    () => ({
      setPolicyLoadState,
      setSelectedPolicy,
      setDisplayAlert,
      handleBack,
      getPolicy,
      navigate,

      policyLoadState,
      selectedPolicy,
      displayAlert,
      loaPolicies,
    }),
    [selectedPolicy, displayAlert, loaPolicies, policyLoadState]
  );

  return (
    <LOAReimbursementContext.Provider value={data}>
      {props.children}
    </LOAReimbursementContext.Provider>
  );
}

LOAReimbursementProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
